import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './MarkdownRenderer.scss';

export const MarkdownRenderer = ({
  content,
  className = '',
  onSendToGigabot,
}) => {
  const [copied, setCopied] = useState(false);
  const [sent, setSent] = useState(false);

  if (!content) {
    return null;
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      // no-op
    }
  };

  const handleSendToGigabot = () => {
    if (onSendToGigabot) {
      onSendToGigabot(content);
      setSent(true);
      setTimeout(() => setSent(false), 2000);
    }
  };

  return (
    <div className={`markdown-container ${className}`}>
      <div className='markdown-toolbar'>
        <button
          type='button'
          className='markdown-copy'
          onClick={handleCopy}
          aria-label='Copy markdown'
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
        {onSendToGigabot && (
          <button
            type='button'
            className='markdown-send-gigabot'
            onClick={handleSendToGigabot}
            aria-label='Send to Gigabot'
          >
            {sent ? 'Sent!' : 'Send to Gigabot'}
          </button>
        )}
      </div>
      <div className='markdown-renderer markdown-raw'>{content}</div>
    </div>
  );
};

MarkdownRenderer.propTypes = {
  content: PropTypes.string.isRequired,
  className: PropTypes.string,
  onSendToGigabot: PropTypes.func,
};
